/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ValidationResultType {
  SystemError = 'SystemError',
  FormMissingResponse = 'FormMissingResponse',
  RecreateProduct = 'RecreateProduct',
  NoProducts = 'NoProducts',
  Ok = 'Ok',
  JustOneProduct = 'JustOneProduct'
}
